import { UmpireReportForSessionChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const UmpirePitchCallChartSidebar = (props: ChartConfigProps<TableChartConfigDto, UmpireReportForSessionChartConfigDto>) => {
  return <TableChartSidebar chartId='UmpirePitchCallChart' chartKey='umpirePitchCallChartConfig' {...props} />;
};

export default UmpirePitchCallChartSidebar;
